import { IModel } from "../@types/models/model";
import { commonFields } from "./helpers/commonFields";
import { coreFields } from "./helpers/coreFields";
import { buttonFields } from "./helpers/buttonFields";


const Komentar: IModel = {
  title: "Komentari",
  apiPath: "komentari",
  httpUpdateVerb: "put",
  forms : {
    "default": {
      fields: [
        "created_by"
        , "created_on"
        ,{ source: "komentar", readonly: true}
        ,{ source: "slike", readonly: true}
      , { source: "hgss_napomena", readonly: true}
      , { source: "hps_napomena", readonly: true}
    ]
    },
    "insert": {
      fields: ["komentar", "slike"]
    },
    "insert-hgss": {
      fields: ["komentar", "hgss_napomena", "slike"]
    },
    "insert-hps": {
      fields: ["komentar", "hps_napomena", "slike"]
    },
    "update":
    {
      fields: [
        { source: "komentar", readonly: true}, "slike"]
    },
    "update-hgss": {
      fields: [
        "created_by"
        , "created_on"
        , { source: "contact_email", readonly: true}
        , { source: "komentar", readonly: true} 
        , { source: "slike", readonly: true}
        , "hgss_napomena"
        , { source: "hps_napomena", readonly: true}
        , "assigned_to_id"
        , "status_id"
        ]
    },
    "update-hps": {
      fields: [
        "created_by"
        , "created_on"
        , { source: "contact_email", readonly: true}
        , { source: "komentar", readonly: true}
        , { source: "slike", readonly: true}
        , { source: "hgss_napomena", readonly: true}
        , "hps_napomena"
        , "assigned_to_id"
        , "status_id"
      ]
    },
    "insert-public": {
      fields: ["komentar", "contact_email", "slike"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "created_by", "komentar", "show_on_map"],
      hidden: ["id"]
    },
    "admin": {
      fields: ["id", "active", "created_by", "created_on", "contact_email", "komentar", "objekt_type", "objekt_id", "hgss_zemljovid", "planina", 
      "podrucje", "modified_by", "hgss_napomena", "hps_napomena", "assigned_to_name", "status_id", "slike"],
      hidden: ["id", "active"]
    },
    "reg_or_hps": {
      fields: ["id", "created_by", "created_on", "komentar", "objekt_type", "objekt_id",  "planina", "podrucje", "slike"],
      hidden: ['id', 'created_by']
    },
    "related_komentari": {
      fields: ["id", "active", "created_by", "created_on", "contact_email", "komentar", "hgss_napomena", "hps_napomena", "assigned_to_name", "status_id", "slike"],
      hidden: ["id", "active"]
    },
    "my_related_komentari": {
      fields: ["id", "created_by", "created_on", "komentar", "slike"],
      hidden: ['id', "created_by"]
    },
    "map": {
      fields: ["created_on","created_by","komentar"]
    }
  },
  fields: [
    coreFields.id,
    coreFields.active,
    commonFields.wkt,
    commonFields.proj,
    {
      title: "Objekt type",
      source: "objekt_type",
      ttoken: "komentari.objekt_type",
      type: "picker",
      items: {
        values: ["poi", "staze", "route"],
        labels: ["common.poi", "common.staza", "common.route"], 
        icons: ['location_pin', 'hiking', 'timeline'],
        iconColors: ['#ff4c4c','#ff4c4c','#ff4c4c']
      },
      readonly: true,
      filter: true
    },
    {
      title: "Objekt ID",
      source: "objekt_id",
      ttoken: "komentari.objekt_id",
      type: "numeric",
      filterType: "text",
      readonly: true,
      filter: true,
      sort: true,
    },
    {
      title: "Komentar",
      source: "komentar",
      ttoken: "data.komentar",
      type: "multiline",
      rows: 6,
      validation: {
        maxLength: 500,
        required: true
      },
      filter: true,
      width: "full",
      tooltip: "data.komentar_tooltip"
    },
    coreFields.created_by,
    coreFields.modified_by,
    coreFields.created_on,
    coreFields.modified_on,
    commonFields.hgss_modified_on,
    commonFields.hgss_modified_by,
    commonFields.hps_modified_on,
    commonFields.hps_modified_by,
    {
      title: "x",
      source: "x",
      ttoken: "data.x",
      type: "numeric",
      readonly: true
    },
    {
      title: "y",
      source: "y",
      ttoken: "data.y",
      type: "numeric",
      readonly: true
    },
    commonFields.hgss_zemljovid,
    commonFields.podrucje,
    commonFields.planina,
    buttonFields.show_on_map,
    {
      title: "slike",
      source: "slike",
      ttoken: "common.fotografije",
      type: "images",
      maxFiles: 3,
      width: "full"
    },
    {
      title: "HGSS Napomena",
      source: "hgss_napomena",
      ttoken: "komentari.hgss_napomena",
      type: "multiline",
      rows: 3,
      width: "full",
      filter: true
    },
    {
      title: "HPS Napomena",
      source: "hps_napomena",
      ttoken: "komentari.hps_napomena",
      type: "multiline",
      rows: 3,
      width: "full",
      filter: true
    },
    {
      title: "Contact E-mail",
      source: "contact_email",
      ttoken: "common.email",
      type: "mail",
      validation: {
        maxLength: 250,
        function: "email"
      },
      width: "full"
    },
    {
      title: "Assigned To (picker)",
      source: "assigned_to_id",
      ttoken: "komentari.assigned_to",
      type: "picker",
      subModel: {
        apiPath: "komentari/administrators",
        format: "{label}"
      }
    },
    {
      title: "Assigned To (name only)",
      source: "assigned_to_name",
      ttoken: "komentari.assigned_to",
      type: "text",
      readonly: true
    },
    {
      title: "Status",
      source: "status_id",
      ttoken: "komentari.status",
      type: "picker",
      items: {
        labels: ['komentar_statusi.zaprimljen', 'komentar_statusi.u_procesu', 'komentar_statusi.rijesen', 'komentar_statusi.odbijen'],
        values: [10, 20, 30, 90],
        icons: ['mail', 'drafts', 'done_all', 'block'],
        iconColors: ['#3182bd', '#feb24c','#31a354', '#de2d26'],
      },
      translate: true
    },
  ]
}

export default Komentar;